import Vue from 'vue'
import App from './App.vue'
import Mainform from './Mainform.vue'
import Finish from './Finish.vue'
import Print from './components/Print.vue'
import VueRouter from 'vue-router'
import axios from 'axios';
import VueSwal from 'vue-swal'
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate);
Vue.use(VueSwal)
Vue.use(VueRouter)
Vue.prototype.$http = axios;

Vue.config.productionTip = false
Vue.mixin({
  data() {
    return {
      itseconfig:{
        token:'ABC',
        key:'123',
        baseurl:'https://sts.ug.edu.gh/itsev8engine/api/alumnirelation',
        payment:'https://sts.ug.edu.gh/itsev8engine/api/gateway/payments',
        pickDescription:function(tickettype,daypasstype=null){
          let desc = '';
          switch (tickettype) {
              case 'FAMILY RATE':
                  desc = 'FAMILY RATE rooms are double occupancy(for adults) plus 3 in a room(for 3 children under 15).';
              break;
              case 'V.I.P':
                  desc = 'V.I.P rooms are single occupancy en-suite.';
              break;
             case 'EXECUTIVE':
                  desc = 'Executive rooms are single occupancy with shared facility.';
             break;
             case 'STANDARD':
                  desc = 'Standard rooms are two occupants in a room with shared facility.';
             break;
             case 'B. PACK':
                  desc = 'B. PACK rooms are four occupants in a room with shared facility.';
             break;
              case 'DAY PASS':
                  desc = daypasstype==null ? '' : daypasstype;
             break;
              default:
            
                  break;
          }
          return desc;
        }
       
      }
    }
  },
  created: function () {
   //return this.csrf;
  }
});
const router = new VueRouter({
  routes:[
    {path:'/',component:Mainform},
    {path:'/status',component:Finish},
    {path:'/print',component:Print}
  ]
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
